export type ContractId = 'PERFECT_LEDGER' | 'RAPID_SETTLEMENT' | 'CLEAN_SWEEP'

export interface ContractContext {
  readonly victory: boolean
  readonly coreIntegrity: number
  readonly runKills: number
  readonly earlyWaveBonus: number
}

export interface ContractDefinition {
  readonly id: ContractId
  readonly name: string
  readonly codename: string
  readonly objective: string
  readonly rewardXp: number
  readonly scoreBonus: number
  readonly color: string
  readonly evaluate: (context: ContractContext) => boolean
}

export const CONTRACTS: Record<ContractId, ContractDefinition> = {
  PERFECT_LEDGER: {
    id: 'PERFECT_LEDGER',
    name: 'PERFECT LEDGER',
    codename: 'ZERO BREACH',
    objective: 'Win with 100% Core integrity.',
    rewardXp: 120,
    scoreBonus: 2_000,
    color: '#35d8ea',
    evaluate: ({ victory, coreIntegrity }) => victory && coreIntegrity === 100,
  },
  RAPID_SETTLEMENT: {
    id: 'RAPID_SETTLEMENT',
    name: 'RAPID SETTLEMENT',
    codename: 'TEMPO',
    objective: 'Win after earning at least 300 USDT from early deployments.',
    rewardXp: 100,
    scoreBonus: 1_700,
    color: '#f3a446',
    evaluate: ({ victory, earlyWaveBonus }) => victory && earlyWaveBonus >= 300,
  },
  CLEAN_SWEEP: {
    id: 'CLEAN_SWEEP',
    name: 'CLEAN SWEEP',
    codename: 'PURGE',
    objective: 'Win after destroying at least 60 hostile processes.',
    rewardXp: 110,
    scoreBonus: 1_850,
    color: '#37e2ae',
    evaluate: ({ victory, runKills }) => victory && runKills >= 60,
  },
}

export const CONTRACT_IDS = Object.keys(CONTRACTS) as ContractId[]
